import Amplify, {Auth} from 'aws-amplify';
import storage from 'store';

import utils from '@utils';

/**
 * init
 */
export const init = () => {
  const env: any = utils.env.get();

  Amplify.configure({
    Auth: {
      region: env.COGNITO_REGION,
      userPoolId: env.COGNITO_USER_POOL_ID,
      userPoolWebClientId: env.COGNITO_CLIENT_ID,
    },
  });
};

/**
 * SignIn
 * @param email
 * @param password
 */
export const signIn = async (email: string, password: string) => {
  const user = await Auth.signIn({
    username: email,
    password,
  });

  return user;
};

/**
 * SignUp
 * @param email
 * @param password
 */
export const signUp = async (email: string, password: string) => {
  const newUser = await Auth.signUp({
    username: email,
    password,
    attributes: {
      email,
    },
  });

  return newUser;
};

/**
 * ConfirmSignUp
 * @param email
 * @param code
 */
export const confirmSignUp = async (email: string, code: string) => {
  const user = await Auth.confirmSignUp(email, code);
  return user;
};

/**
 * SignOut
 */
export const signOut = async () => {
  // After retrieving the confirmation code from the user
  const result = await Auth.signOut();
  storage.clearAll();
  return result;
};

/**
 * ChangePassword
 * @param oldPassword
 * @param newPassword
 */
export const changePassword = async (
  oldPassword: string,
  newPassword: string
) => {
  const user = await Auth.currentAuthenticatedUser();
  const result = await Auth.changePassword(user, oldPassword, newPassword);

  return result;
};

/**
 * ForgotPassword
 * @param username
 */
export const forgotPassword = async (username: string) => {
  const result = await Auth.forgotPassword(username);
  return result;
};

/**
 * ForgotPasswordSubmit
 */
export const forgotPasswordSubmit = async (
  username: string,
  code: string,
  newPassword: string
) => {
  await Auth.forgotPasswordSubmit(username, code, newPassword);
};

/**
 * GetUser
 */
export const getUser = async () => {
  const user = await Auth.currentAuthenticatedUser({
    bypassCache: false,
  });

  return user;
};

/**
 * GetCurrentSession
 */
export const getCurrentSession = async () => {
  try {
    const result = await Auth.currentSession();
    return result;
  } catch (err) {
    return err;
  }
};

/**
 * GetIdToken
 */
export const getIdToken = async () => {
  try {
    const session = await Auth.currentSession();
    const token = session.getIdToken().getJwtToken();

    return token;
  } catch (err) {
    console.error(err);
    return false;
  }
};

export const completeNewPassword = async (
  cognitoUser: any,
  password: string
) => {
  // const {username, email, phone_number} = getInfoFromUserInput();
  const loggedUser = await Auth.completeNewPassword(cognitoUser, password, {});

  return loggedUser;
};
// 認証コードの再送信
export const resendConfirm = async (email: string) => {
  await Auth.resendSignUp(email);
};
